@if (progress.progressBar$ | async) {
  <div class="bar-overlay">
    <mat-progress-bar class="loading-progress-bar" mode="indeterminate"></mat-progress-bar>
  </div>
}
